import styled from 'styled-components'

const StyledCouponState = styled.div``

export default StyledCouponState
